// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "small[data-v-c33fe69e]{font-size:.5em}p[data-v-c33fe69e]{display:block}", ""]);
// Exports
module.exports = exports;
